import { rssFeeds } from '../config/rssFeeds.mjs';
import { FeedFetcher } from './feedFetcher.mjs';
import { FeedParser } from './feedParser.mjs';
import { defaultFeeds } from './defaultFeeds.mjs';

export class FeedService {
  static isUpdating = false;

  static async fetchFeeds() {
    console.log('Starting feed fetch...');
    const feedPromises = rssFeeds.map(async (feed) => {
      try {
        console.log(`Fetching feed: ${feed.name}`);
        const response = await FeedFetcher.fetchFeed(feed.url);
        const items = FeedParser.parseFeed(response, feed);
        
        if (items.length === 0) {
          console.warn(`No items parsed from ${feed.name}`);
        } else {
          console.log(`Successfully parsed ${items.length} items from ${feed.name}`);
        }
        
        return items;
      } catch (error) {
        console.error(`Error fetching feed ${feed.name}:`, error);
        return [];
      }
    });

    try {
      const results = await Promise.allSettled(feedPromises);
      const successfulResults = results
        .filter((result) => result.status === 'fulfilled' && result.value.length > 0)
        .map((result) => result.value)
        .flat();

      console.log(`Total items fetched: ${successfulResults.length}`);
      
      if (successfulResults.length === 0) {
        console.error('No feeds were successfully fetched');
        return defaultFeeds;
      }
      
      return successfulResults.sort((a, b) => 
        new Date(b.date).getTime() - new Date(a.date).getTime()
      );
    } catch (error) {
      console.error('Error processing feeds:', error);
      return defaultFeeds;
    }
  }
}